import React from 'react'
import { useSelector } from 'react-redux'

import { calculateImpressionsFromBudget } from '../../../../UploadAdCreative/ImpressionsBudgetSection/helpers'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import { BUDGET_LIFETIME } from '../../../../CampaignForms/fields'

const ImpressionsBudgetSectionPreview = ({ campaign }) => {
  const { bid_cap: rightBidCap } = useSelector(rightSelector)

  const impressions = calculateImpressionsFromBudget({
    budget: campaign?.[BUDGET_LIFETIME],
    rightBidCap
  })

  return <p>{impressions}</p>
}

export default ImpressionsBudgetSectionPreview
